import { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useHttpClient } from '../../../shared/http-client';
import { PageBody } from '../../../elements/page-body';
import { Button } from '../../../elements/button';
import { Map } from '../../../elements/map';
import { formatDateTime } from '../../../utils';
import { MapContainer, TileLayer, Marker, Polyline, useMap } from 'react-leaflet';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
import icon from 'leaflet/dist/images/marker-icon.png';
import iconShadow from 'leaflet/dist/images/marker-shadow.png';



const initialValues = {
    date: '',
};


const formatDateYMDToDMY = (value: string | null | undefined) => {
    if (!value) return '';
    const match = /^\d{4}-\d{2}-\d{2}$/.test(value);
    if (!match) return value;
    const [year, month, day] = value.split('-');
    return `${day}-${month}-${year}`;
};

const DefaultIcon = L.icon({
    iconUrl: icon,
    shadowUrl: iconShadow,
    iconAnchor: [12, 41],
    popupAnchor: [1, -34]
});

L.Marker.prototype.options.icon = DefaultIcon;

const FitBounds = ({ coordinates }: { coordinates: any[] }) => {
    const map = useMap();

    useEffect(() => {
        if (coordinates && coordinates.length > 1) {
            const bounds = L.latLngBounds(coordinates);
            map.fitBounds(bounds, { padding: [50, 50] });
        }
    }, [coordinates, map]);

    return null;
};

const MapContainerAny = MapContainer as any;
const TileLayerAny = TileLayer as any;
const MarkerAny = Marker as any;
const PolylineAny = Polyline as any;




export const RoutesDetail = () => {
    const { t } = useTranslation() as { t: (key: string) => string };
    const { api, state } = useHttpClient();
    const { id } = useParams();
    const navigate = useNavigate();
    const [data, setData] = useState<any | null>(null);
    const [showSteps, setShowSteps] = useState<any>({});
    const [viewMode, setViewMode] = useState<'steps' | 'route'>('steps');

    useEffect(() => {
        if (id) {
            api(`/fleet/routes/${id}/`, 'GET');
        }
    }, [id]);

    const handleShow = (index: number) => {
        setShowSteps((prev: any) => ({
            ...prev,
            [index]: !prev[index]
        }));
    };

    // Handle API responses
    useEffect(() => {
        if (state.data) {
            if (state.path.includes('routes')) {

                console.log('state.data', state.data)
                setData(state.data)

            }
        }

        if (state.error) {

        }
    }, [state]);

    return (
        <div className='p-8'>
            <>
                <div
                    className="pb-8 cursor-pointer"
                    onClick={() => navigate(-1)}
                >
                    <span>{'< '}</span>
                    <span>{t('common.button.back')}</span>
                </div>
                {data && <div className='text-lg'>{t('common.label.ruta')} {data.code}</div>}
                <div className="py-4 bg-gray-100 rounded-md my-4">
                    {data && (
                        <>
                            <div className='w-full h-36 flex border border-gray-300 bg-white py-2 pl-3 pr-10 shadow-sm rounded-md items-center'>
                                <div>
                                    <div className='h-24'>
                                        {data?.vehicle?.photo_display_url ? <img className='h-[120px] pb-4' src={data?.vehicle?.photo_display_url} /> : <div className='w-[180px] h-[120px] bg-gray-300 flex items-center justify-center'><span className='text-gray-500 text-sm'>{t('common.form-label.image-vehicle')}</span></div>}
                                    </div>
                                </div>
                                <div className='pl-8'>
                                    <div className='text-[13px]'><span className='font-semibold'>{t('common.labels.date')}:</span> {formatDateYMDToDMY(data?.date)}</div>
                                    <div className='text-[13px]'><span className='font-semibold'>{t('common.label.area')}:</span> {data?.area?.name}</div>
                                    <div className='text-[13px]'><span className='font-semibold'>{t('common.label.comercial')}:</span> {data?.driver?.full_name}</div>
                                    <div className='text-[13px]'><span className='font-semibold'>{t('common.label.vehiculo')}:</span> {data?.vehicle?.plate}</div>
                                </div>
                                <div className='pl-8'>
                                    <div className='text-[13px]'><span className='font-semibold'>{t('common.label.visita')}:</span> {data?.service_display}</div>
                                    <div className='text-[13px]'><span className='font-semibold'>{t('common.label.duracion-trayecto')}:</span> {data?.duration_display}</div>
                                    <div className='text-[13px]'><span className='font-semibold'>{t('common.label.duracion-espera')}:</span> {data?.waiting_time_display}</div>
                                    <div className='text-[13px]'><span className='font-semibold'>{t('common.label.duracion-total-min')}:</span> {data?.total_duration_display}</div>
                                </div>

                            </div>
                            <div className='pt-4 pb-2 flex gap-4'>
                                <button
                                    onClick={() => setViewMode('steps')}
                                    className={`px-4 py-2 rounded-md transition-colors ${viewMode === 'steps' ? 'bg-primary text-white text-sm' : 'bg-gray-200 text-gray-700 hover:bg-gray-300 text-sm'}`}
                                >
                                    {t('common.button.mostrar-pasos')}
                                </button>
                                <button
                                    onClick={() => setViewMode('route')}
                                    className={`px-4 py-2 rounded-md transition-colors ${viewMode === 'route' ? 'bg-primary text-white text-sm' : 'bg-gray-200 text-gray-700 hover:bg-gray-300 text-sm'}`}
                                >
                                    {t('common.button.mostrar-ruta-total')}
                                </button>
                            </div>
                            <div className='pt-2'>
                                {viewMode === 'route' && data.steps.length > 0 && (() => {
                                    const startStep = data.steps.find((step: any) => step.step_type === 'start');
                                    const endStep = data.steps.find((step: any) => step.step_type === 'end');
                                    const centerLocation = startStep ? [startStep.location[1], startStep.location[0]] : [data.steps[0].location[1], data.steps[0].location[0]];
                                    
                                    // Filter out break steps for the polyline (they have invalid coordinates)
                                    const validSteps = data.steps.filter((step: any) => step.step_type !== 'break');
                                    
                                    return (
                                        <div className='w-full border border-gray-300 bg-white shadow-sm rounded-md mb-4' style={{ height: '500px' }}>
                                            <MapContainerAny
                                                center={centerLocation}
                                                zoom={12}
                                                style={{ height: '100%', width: '100%' }}
                                            >
                                                <TileLayerAny
                                                    attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                                                    url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                                                />
                                                <PolylineAny
                                                    positions={validSteps.map((step: any) => [step.location[1], step.location[0]])}
                                                    color="blue"
                                                    weight={4}
                                                    opacity={0.7}
                                                />
                                                {(() => {
                                                    const startStepData = validSteps.find((s: any) => s.step_type === 'start');
                                                    const endStepData = validSteps.find((s: any) => s.step_type === 'end');
                                                    const sameLocation = startStepData && endStepData && 
                                                        startStepData.location[0] === endStepData.location[0] && 
                                                        startStepData.location[1] === endStepData.location[1];
                                                    
                                                    return validSteps.map((step: any, idx: number) => {
                                                        const isStart = step.step_type === 'start';
                                                        const isEnd = step.step_type === 'end';
                                                        
                                                        // Skip end marker if it's in the same location as start
                                                        if (isEnd && sameLocation) {
                                                            return null;
                                                        }
                                                        
                                                        let color = 'blue';
                                                        let label = `${idx + 1}`;
                                                        
                                                        if (isStart && sameLocation) {
                                                            // Combined start/end marker
                                                            color = 'linear-gradient(90deg, green 50%, red 50%)';
                                                            label = `${t('common.label.inicio')}/${t('common.form-label.final')}`;
                                                        } else if (isStart) {
                                                            color = 'green';
                                                        } else if (isEnd) {
                                                            color = 'red';
                                                        }
                                                        
                                                        const isGradient = color.includes('gradient');
                                                        
                                                        return (
                                                            <MarkerAny
                                                                key={idx}
                                                                position={[step.location[1], step.location[0]]}
                                                                icon={L.divIcon({
                                                                    className: 'custom-marker',
                                                                    html: `<div style="background: ${color}; color: white; border-radius: ${isGradient ? '4px' : '50%'}; width: ${isGradient ? 'auto' : '24px'}; height: ${isGradient ? '24px' : '24px'}; ${isGradient ? 'padding: 4px 8px;' : ''} display: flex; align-items: center; justify-content: center; font-weight: bold; font-size: ${isGradient ? '10px' : '12px'}; border: 2px solid white; box-shadow: 0 2px 5px rgba(0,0,0,0.3); white-space: nowrap;">${label}</div>`,
                                                                    iconSize: [isGradient ? 80 : 24, isGradient ? 24 : 24],
                                                                    iconAnchor: [isGradient ? 40 : 12, isGradient ? 12 : 12],
                                                                })}
                                                            />
                                                        );
                                                    }).filter(Boolean);
                                                })()}
                                                <FitBounds coordinates={validSteps.map((step: any) => [step.location[1], step.location[0]])} />
                                            </MapContainerAny>
                                        </div>
                                    );
                                })()}
                                {viewMode === 'steps' && data.steps.map((item: any, index: number) => {
                                    return <div className='w-full flex border border-gray-300 bg-white py-2 pl-3 pr-10 shadow-sm rounded-md mb-2'>
                                        {item.step_type !== 'break' ? (
                                            <div className='w-2/3 h-48'>
                                                <Map longitude={item.location[0]} latitude={item.location[1]} markerType={item.step_type} />
                                            </div>
                                        ) : null}
                                        <div className={`${item.step_type !== 'break' ? 'w-1/3 pl-8' : 'w-full'}`}>
                                            {item.step_type == 'start' ?
                                                <div>

                                                    <div className='text-[13px]'><span className='font-semibold'>{t('common.form-label.salida')}:</span> {formatDateTime(item.arrival_display)}</div>
                                                    {/*       <div className='text-[13px]'><span className='font-semibold'>{t('common.form-label.address')}:</span> {item?.customer.address}</div> */}
                                                </div>
                                                : ''}

                                            {item.step_type == 'break' ?
                                                <div>
                                                    <div className='text-[13px]'><span className='font-semibold'>{t('common.label.parada')}</span></div>
                                                    <div className='text-[13px] pt-[2px]'><span className='font-semibold'>{t('common.label.hora-llegada')}:</span> {item?.arrival_display ? item.arrival_display.split(' ')[1]?.slice(0, 5) : ''}</div>
                                                    <div className='text-[13px]'><span className='font-semibold'>{t('common.label.duracion')}:</span> {item?.service_display}</div>
                                                </div>
                                                : ''}

                                            {item.step_type == 'end' ?
                                                <div className='text-[13px] pt-[2px]'><span className='font-semibold'>{t('common.label.hora-llegada')}:</span> {item?.arrival_display ? item.arrival_display.split(' ')[1]?.slice(0, 5) : ''}</div>
                                                : ''}

                                            {item.step_type == 'job' ? <>
                                                <div className='text-[13px] pt-[2px]'><span className='font-semibold'>{t('common.label.hora-llegada')}:</span> {item?.arrival_display ? item.arrival_display.split(' ')[1]?.slice(0, 5) : ''}</div>
                                                {item.customer ? <div className='flex flex-start items-center'>

                                                    <div className='text-[13px] pt-[2px]'><span className='font-semibold'>{t('common.form-label.cliente')}:</span> {item?.customer.name}</div>
                                                    <div className='pl-4'><span className={`inline-block px-2 py-1 text-xs font-semibold rounded ${item.customer.is_acquired
                                                        ? 'bg-green-100 text-green-800'
                                                        : 'bg-blue-100 text-blue-800'
                                                        }`}>
                                                        {item.customer.is_acquired
                                                            ? t('common.form-label.cliente')
                                                            : t('common.label.prospecto')
                                                        }
                                                    </span></div>

                                                </div> : ''}
                                                {item.customer ? <div className='text-[13px]'><span className='font-semibold'>{t('common.form-label.address')}:</span> {item?.customer.address}</div> : ''}

                                                <div className='text-[13px]'><span className='font-semibold'>{t('common.label.visita')}:</span> {item?.service_display}</div>
                                                <div className='text-[13px]'><span className='font-semibold'>{t('common.label.duracion-trayecto')}:</span> {item?.duration_display}</div>
                                                <div className='text-[13px]'><span className='font-semibold'>{t('common.label.duracion-espera')}:</span> {item?.waiting_time_display}</div>
                                                <div className='text-[13px]'><span className='font-semibold'>{t('common.label.duracion-total-min')}:</span> {item?.total_duration_display}</div></> : ''}

                                        </div>
                                    </div>
                                })}
                            </div>
                        </>

                    )}
                </div>
            </>
        </div>
    );
};